import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks";
import { setThemeMode } from "../store/themeSlice";
import { useConfiguration } from "../hooks/useConfiguration";
import {
  useIsSharedTerminalWithoutEmployee,
  useSharedAccountInfo,
} from "../hooks/useSharedAccountInfo";
import { readDeviceTheme, saveDeviceTheme } from "../lib/theme";
import type { ThemeMode } from "../lib/theme";

/**
 * Темата е на КОМПЮТЪРА (localStorage, lib/theme.ts), не на човека. Този
 * компонент само ПРЕНАСЯ еднократно досегашната лична тема от базата
 * (`user_configuration.theme` от `/user/info`; на ПИН екрана на общ терминал —
 * тази на общия акаунт), ако на компютъра още НЯМА записана — за да не изгуби
 * никой избора си при прехода. Щом има записана, базата не се гледа: на един
 * компютър темата е една и съща за всеки, който влиза.
 * Монтира се веднъж, над router-а (main.tsx).
 */
export default function UserConfigurationSync() {
  const dispatch = useAppDispatch();
  const { configuration, isLoaded } = useConfiguration();
  const sharedTerminalWithoutEmployee = useIsSharedTerminalWithoutEmployee();
  const onPinScreen = !isLoaded && sharedTerminalWithoutEmployee;
  const shared = useSharedAccountInfo();

  let savedTheme: ThemeMode | null = null;
  if (isLoaded) savedTheme = configuration.theme;
  else if (onPinScreen) savedTheme = shared.data?.configuration?.theme ?? null;

  useEffect(() => {
    if (!savedTheme || readDeviceTheme()) return;
    saveDeviceTheme(savedTheme);
    dispatch(setThemeMode(savedTheme));
  }, [savedTheme, dispatch]);

  return null;
}
